import {
  decodeStoredAuthToken,
  getStoredAuthToken,
  handleUnauthorizedSession,
} from "./authSession";

export const BASE_API = window.BASE_API;
export const FILE_BASE = window.FILE_BASE || window.BASE_API || "";
export const FILE_BASE_RECORDING = window.FILE_BASE_RECORDING || window.BASE_API || "";
export const IF_FORWARDING = false;

export const enable_stream = true;

const parseJsonSafely = async (response) => {
  try {
    return await response.json();
  } catch (error) {
    return {};
  }
};

const buildAuthHeaders = (headers = {}) => {
  const token = getStoredAuthToken();
  if (!token) {
    return { token: "", headers: { ...headers } };
  }

  return {
    token,
    headers: {
      Authorization: "Bearer " + token,
      ...headers,
    },
  };
};

const shouldInvalidateSession = (response, token, errorData = {}) => {
  if (!token || !response) {
    return false;
  }

  if (response.status === 401) {
    return true;
  }

  if (response.status !== 403) {
    return false;
  }

  const message = String(
    errorData?.message || errorData?.error || errorData?.msg || ""
  ).trim().toLowerCase();

  return (
    message === "invalid or expired token" ||
    message === "authentication token is required" ||
    message === "session expired"
  );
};

export const buildAuthenticatedHeaders = (headers = {}) =>
  buildAuthHeaders(headers).headers;

export const buildAuthenticatedEventSourceUrl = (path = "", params = {}) => {
  if (!BASE_API) {
    return null;
  }

  const url = new URL(`${BASE_API}${path}`, window.location.origin);
  const token = getStoredAuthToken();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      url.searchParams.set(key, value);
    }
  });

  if (token) {
    url.searchParams.set("token", token);
  }

  return url.toString();
};

export const getLiveStreamUrl = ({ userId = "", userType = null, admin = false } = {}) => {
  if (!BASE_API) {
    return null;
  }

  if (admin || Number(userType) === 1) {
    return buildAuthenticatedEventSourceUrl("api/live-calls/stream/admin");
  }

  if (!userId) {
    return null;
  }

  return buildAuthenticatedEventSourceUrl("api/live-calls/stream", {
    user_id: userId,
  });
};

export const DecryptToken = () => {
  return decodeStoredAuthToken();
};


export async function CallGETAPI(url, params = "", headers = {}) {
  try {
    const { token, headers: allHeaders } = buildAuthHeaders(headers);
    let res = await fetchWithTimeout(BASE_API + url + params, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...allHeaders,
      },
    });

    if (res.status === 401 || res.status === 403) {
      const errorData = await parseJsonSafely(res);

      if (shouldInvalidateSession(res, token, errorData)) {
        handleUnauthorizedSession();
      }

      return { status: false, msg: errorData?.message || "Session expired", data: errorData };
    }

    if (!res.ok) {
      const errorData = await parseJsonSafely(res);
      return { status: false, msg: errorData?.message || "No Data Found", data: errorData };
    }
    let resultData = await res.json();
    return { status: true, msg: "", data: resultData };
  } catch (e) {
    return { status: false, msg: e.message, data: [] };
  }
}

// export async function CallPOSTAPI(url, params = [], headers = {}) {
//   try {
//     let token = localStorage.getItem("psx_token");
//     let AllHeaders = { ...headers };
//     if (token) {
//       AllHeaders = { Authorization: "Bearer " + token, ...headers };
//     }

//     let res = await fetchWithTimeout(BASE_API + url, {
//       method: "POST",
//       headers: { "Content-Type": "application/json", ...AllHeaders },
//       body: JSON.stringify(params),
//     });
//     let resultData = await res.json();

//     if (!res.ok) {
//       return { status: false, msg: resultData?.message || "Unknown error", data: [] };
//     }
//     return { status: true, msg: resultData?.message || "Success", data: resultData };
//   } catch (e) {
//     return { status: false, msg: e.message || "Unknown error", data: [] };
//   }
// }

export async function CallPOSTAPI(url, data, headers = {}) {
  try {
    const { token, headers: allHeaders } = buildAuthHeaders(headers);
    let res = await fetchWithTimeout(BASE_API + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...allHeaders,
      },
      body: JSON.stringify(data),
    });

    if (res.status === 401 || res.status === 403) {
      const errorData = await parseJsonSafely(res);

      if (shouldInvalidateSession(res, token, errorData)) {
        handleUnauthorizedSession();
      }

      return {
        status: false,
        data: errorData?.message ? errorData : { message: "Session expired" },
      };
    }

    if (!res.ok) {
      const errorData = await parseJsonSafely(res);
      return { status: false, data: errorData }; // Return the error data
    }

    let resultData = await res.json();
    return { status: true, data: resultData };
  } catch (e) {
    return { status: false, data: { message: e.message } }; // Return the error message
  }
}



// import { jwtDecode } from "jwt-decode";

// export const BASE_API = window.BASE_API;
// export const FILE_BASE = window.BASE_API;
// export const FILE_BASE_RECORDING = window.FILE_BASE_RECORDING;

// // Function to handle token expiration and redirect
// const handleTokenExpiration = () => {
//   // Remove token and user type from localStorage
//   localStorage.removeItem("psx_token");
//   localStorage.removeItem("user_type");

//   // Redirect to login page
//   window.location.href = "/";
// };

// export const DecryptToken = () => {
//   let token = "";
//   if (typeof window !== "undefined") {
//     token = localStorage.getItem("psx_token") || "";
//   }

//   let decoded = {};

//   if (token !== "" && token !== "undefined") {
//     try {
//       decoded = jwtDecode(token);

//       // Check if token is expired
//       const currentTime = Math.floor(Date.now() / 1000);
//       if (decoded.exp && decoded.exp < currentTime) {
//         handleTokenExpiration();
//       }
//     } catch (error) {
//       // If token decoding fails, handle it as an expired token
//       handleTokenExpiration();
//     }
//   }

//   return decoded;
// };

// export async function CallGETAPI(url, params = "", headers = {}) {
//   try {
//     let token = localStorage.getItem("psx_token");
//     let AllHeaders = { ...headers };
//     if (token) {
//       AllHeaders = { Authorization: "Bearer " + token, ...headers };
//     }

//     let res = await fetchWithTimeout(BASE_API + url + params, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         ...AllHeaders,
//       },
//     });

//     // Check for 403 Forbidden status
//     if (res.status === 403) {
//       handleTokenExpiration();
//       return { status: false, msg: "Session expired", data: [] };
//     }

//     if (!res.ok) {
//       return { status: false, msg: "No Data Found", data: [] };
//     }

//     let resultData = await res.json();
//     return { status: true, msg: "", data: resultData };
//   } catch (e) {
//     return { status: false, msg: e.message, data: [] };
//   }
// }

// export async function CallPOSTAPI(url, data, headers = {}) {
//   try {
//     let token = localStorage.getItem("psx_token");
//     let AllHeaders = { ...headers };
//     if (token) {
//       AllHeaders = { Authorization: "Bearer " + token, ...headers };
//     }

//     let res = await fetchWithTimeout(BASE_API + url, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         ...AllHeaders,
//       },
//       body: JSON.stringify(data),
//     });

//     // Check for 403 Forbidden status
//     if (res.status === 403) {
//       handleTokenExpiration();
//       return {
//         status: false,
//         data: { message: "Session expired. Please login again." }
//       };
//     }

//     if (!res.ok) {
//       const errorData = await res.json();
//       return { status: false, data: errorData };
//     }

//     let resultData = await res.json();
//     return { status: true, data: resultData };
//   } catch (e) {
//     return { status: false, data: { message: e.message } };
//   }
// }

// ... rest of your existing code remains the same

export async function CallPostFileUpload(url, params, headers = {}) {
  try {
    const { token, headers: allHeaders } = buildAuthHeaders(headers);
    //             // headers:{'Content-Type':'application/json',...AllHeaders},

    let res = await fetchWithTimeout(BASE_API + url, {
      method: "POST",
      headers: allHeaders,
      body: params,
    });

    if (shouldInvalidateSession(res, token)) {
      const errorData = await parseJsonSafely(res);
      handleUnauthorizedSession();
      return { status: false, msg: errorData?.message || "Session expired", data: errorData };
    }

    if (!res.ok) {
      const errorData = await parseJsonSafely(res);
      return { status: false, msg: errorData?.message || "No Data Found", data: errorData };
    }
    let resultData = await res.json();
    return { status: true, msg: "", data: resultData };
  } catch (e) {
    return { status: false, msg: e.message, data: [] };
  }
}


export const DeleteCRTByPkId =  async (id)=>{
  const res  = await CallGETAPI('api/delete-call-routing/'+id);
  return res;
}

// Bound requests without conflating a network timeout with rejected credentials.
async function fetchWithTimeout(url, options = {}) {
  return fetch(url, { ...options, signal: options.signal || AbortSignal.timeout(15000) });
}
